const FACTORS = [
  {
    icon: "🏟️",
    name: "Park Factor",
    desc: "Each stadium's historical HR rate vs league average. PNC Park, Comerica, and Petco suppress HRs. Coors Field inflates them dramatically at 5,200ft altitude.",
  },
  {
    icon: "⚾",
    name: "Starter HR/9",
    desc: "Both starting pitchers' season HR/9 rate averaged together. Lower is better for a no-HR outcome. A combined average below 0.70 is a strong signal.",
  },
  {
    icon: "📊",
    name: "Team Slugging %",
    desc: "Rolling 30-day slugging % for both offenses. Lower SLG means less raw power in the lineup, reducing the probability of any HR being hit.",
  },
  {
    icon: "💰",
    name: "Game Total",
    desc: "The sportsbook over/under reflects market expectations for run scoring. Totals under 7.5 correlate strongly with lower HR rates. Above 9.5 is an auto-flag.",
  },
  {
    icon: "🌡️",
    name: "Weather",
    desc: "Temperature and wind direction at game time. Cold air is denser — balls don't carry as far. Wind blowing in toward home plate significantly suppresses HRs. Dome = controlled.",
  },
];

export default function About() {
  return (
    <div style={{ padding: "20px 20px 24px" }}>
      {/* header */}
      <div style={{ marginBottom: 20 }}>
        <div
          style={{
            fontSize: "0.62rem",
            fontWeight: 700,
            letterSpacing: 3,
            textTransform: "uppercase",
            color: "#8090B0",
            marginBottom: 6,
          }}
        >
          How It Works
        </div>
        <div
          style={{
            fontSize: "1.7rem",
            fontWeight: 800,
            letterSpacing: "-0.3px",
          }}
        >
          The <span style={{ color: "#D42B2B" }}>Model</span>
        </div>
      </div>

      {/* baseline callout */}
      <div
        style={{
          background: "#F5F6FA",
          borderRadius: 12,
          padding: "14px 16px",
          marginBottom: 24,
          borderLeft: "3px solid #1535A0",
        }}
      >
        <div
          style={{
            fontSize: "0.82rem",
            fontWeight: 600,
            lineHeight: 1.55,
            color: "#0A1740",
          }}
        >
          In 2024, about{" "}
          <span style={{ color: "#D42B2B", fontWeight: 700 }}>12%</span> of MLB
          games ended with zero home runs. Our model identifies games most
          likely to land in that window using five weighted factors updated
          daily before first pitch.
        </div>
      </div>

      {/* weights bar */}
      <div style={{ marginBottom: 24 }}>
        <div
          style={{
            fontSize: "0.62rem",
            fontWeight: 700,
            letterSpacing: 2,
            textTransform: "uppercase",
            color: "#8090B0",
            marginBottom: 10,
          }}
        >
          Factor Weights
        </div>
        {[
          { label: "SP HR/9", weight: 30, color: "#D42B2B" },
          { label: "Park Factor", weight: 25, color: "#1535A0" },
          { label: "Game Total", weight: 20, color: "#2952C4" },
          { label: "Team SLG", weight: 15, color: "#8090B0" },
          { label: "Weather", weight: 10, color: "#CBD5E8" },
        ].map((w) => (
          <div key={w.label} style={{ marginBottom: 8 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 4,
              }}
            >
              <span
                style={{
                  fontSize: "0.72rem",
                  fontWeight: 600,
                  color: "#0A1740",
                }}
              >
                {w.label}
              </span>
              <span
                style={{ fontSize: "0.72rem", fontWeight: 700, color: w.color }}
              >
                {w.weight}%
              </span>
            </div>
            <div
              style={{
                height: 5,
                background: "#EEF0F6",
                borderRadius: 3,
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  height: "100%",
                  width: `${w.weight * 3}%`,
                  background: w.color,
                  borderRadius: 3,
                }}
              />
            </div>
          </div>
        ))}
      </div>

      {/* 5 factors */}
      <div
        style={{
          fontSize: "0.62rem",
          fontWeight: 700,
          letterSpacing: 2,
          textTransform: "uppercase",
          color: "#8090B0",
          marginBottom: 14,
        }}
      >
        The 5 Factors
      </div>

      {FACTORS.map((f, i) => (
        <div
          key={i}
          style={{
            borderBottom: "1px solid #EEF0F6",
            paddingBottom: 16,
            marginBottom: 16,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginBottom: 6,
            }}
          >
            <span style={{ fontSize: "1.3rem" }}>{f.icon}</span>
            <span style={{ fontSize: "0.92rem", fontWeight: 700 }}>
              {f.name}
            </span>
          </div>
          <div
            style={{
              fontSize: "0.78rem",
              color: "#4A5680",
              lineHeight: 1.55,
            }}
          >
            {f.desc}
          </div>
        </div>
      ))}

      {/* data sources */}
      <div
        style={{
          background: "#F5F6FA",
          borderRadius: 12,
          padding: "14px 16px",
          marginTop: 8,
        }}
      >
        <div
          style={{
            fontSize: "0.72rem",
            fontWeight: 700,
            color: "#0A1740",
            marginBottom: 6,
          }}
        >
          Data Sources
        </div>
        <div
          style={{
            fontSize: "0.72rem",
            color: "#8090B0",
            lineHeight: 1.8,
          }}
        >
          MLB Stats API · The Odds API · Open-Meteo Weather
          <br />
          Updated daily before first pitch · Results verified post-game
          <br />
          <span style={{ color: "#D42B2B", fontWeight: 600 }}>
            Free 2026 season · Not financial advice.
          </span>
        </div>
      </div>
    </div>
  );
}
